<template>
  <div class="admin">
    <h1>This is an admin page</h1>
  </div>
</template>
